import { useContext } from 'react';

import { createPermissionChecker } from '@uptime/shared/utils/permissions';

import { PermissionsContext } from '@/providers/PermissionsProvider';

const ADMIN_FEATURE = 'admin';

const usePermissions = () => {
  const { permissions, setPermissions, hasPermissionsLoaded, setHasPermissionsLoaded } =
    useContext(PermissionsContext);

  // Dummy permission, will be replaced when there are some features
  const adminPermission = createPermissionChecker(permissions)(ADMIN_FEATURE);

  return {
    setPermissions,
    hasPermissionsLoaded,
    setHasPermissionsLoaded,
    adminPermission,
  };
};

export default usePermissions;
